__turbopack_context__.v({
  "actions": "ForgotPasswordForm-drawer-module-scss-module__rVQPVa__actions",
  "backButton": "ForgotPasswordForm-drawer-module-scss-module__rVQPVa__backButton",
  "captchaWrapper": "ForgotPasswordForm-drawer-module-scss-module__rVQPVa__captchaWrapper",
  "confirmation": "ForgotPasswordForm-drawer-module-scss-module__rVQPVa__confirmation",
  "confirmationActions": "ForgotPasswordForm-drawer-module-scss-module__rVQPVa__confirmationActions",
  "confirmationButton": "ForgotPasswordForm-drawer-module-scss-module__rVQPVa__confirmationButton",
  "confirmationHeading": "ForgotPasswordForm-drawer-module-scss-module__rVQPVa__confirmationHeading",
  "confirmationText": "ForgotPasswordForm-drawer-module-scss-module__rVQPVa__confirmationText",
  "emailHighlight": "ForgotPasswordForm-drawer-module-scss-module__rVQPVa__emailHighlight",
  "form": "ForgotPasswordForm-drawer-module-scss-module__rVQPVa__form",
  "submitButton": "ForgotPasswordForm-drawer-module-scss-module__rVQPVa__submitButton",
});
